module.exports = __webpack_public_path__ + "static/media/day-cloud-snow-icon.42ea97f0.svg";